<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    :items="drafts"
    :search="search"
    sort-by="created_at"
    sort-desc
    dense
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>SITUAÇÃO DOS PEDIDOS - FRANQUEADORA</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-btn color="blue darken-1" dark to="/cest/novo">
          <v-icon>mdi-plus</v-icon>
          Novo
        </v-btn> -->
        <alert
          :visible="!!error"
          dark
          type="error"
          :message="error"
          :clickClose="() => (error = '')"
        />
        <alert
          :visible="!!alertSuccess"
          dark
          type="success"
          :message="alertSuccess"
          :clickClose="() => (alertSuccess = '')"
        />
        <v-dialog v-model="dialogRemoveOrder" persistent max-width="480px">
          <v-card>
            <v-card-title>Deletar Pedido</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-4">
              Deseja Realmente deletar esse pedido?
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey darken-1"
                text
                @click="handleCancelRemoveOrder()"
              >
                Fechar
              </v-btn>
              <v-btn
                color="red darken-3"
                class="white--text"
                outlined
                @click="handleConfirmRemoveOrder()"
              >
                <v-icon left>mdi-delete</v-icon>
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.issuance_date="{ item }">
      {{ item.issuance_date | dateFormatBr }}
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.created_at="{ item }">
      {{ item.created_at | datetimeFormatBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.products="{ item }">
      {{ item.products.length }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.value="{ item }">
      {{ item.value | currencyEuaToBr }}
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.status="{ item }">
      <v-chip dense label small :color="getColor(item.status)" dark>
        {{ getLabel(item.status) }}
      </v-chip>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-tooltip top color="blue darken-1">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            color="blue darken-1"
            @click="editOrder(item.id)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-pencil
          </v-icon>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip top color="error">
        <!-- eslint-disable-next-line -->
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="red darken-1"
            @click="removeOrder(item.id)"
            v-bind="attrs"
            v-on="on"
          >
            mdi-delete
          </v-icon>
        </template>
        <span>Deletar</span>
      </v-tooltip>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Recarregar </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import { getStatusName } from "@/helpers/order_status";

export default {
  components: {
    Alert,
  },
  data: () => ({
    headers: [
      {
        text: "Pedido",
        align: "left",
        value: "fullCode",
        width: 50,
      },
      { text: "Franqueado", value: "franchiseFull", width: 200 },
      { text: "Fornecedor", value: "providerFull", width: 200 },
      { text: "Produtos", align: "center", value: "products", width: 80 },
      {
        text: "Qtde.",
        align: "center",
        value: "quantity_items",
        width: 40,
      },
      { text: "Valor", align: "right", value: "value", width: 100 },
      { text: "Emissão", align: "right", value: "issuance_date", width: 150 },
      { text: "Criação", align: "right", value: "created_at", width: 150 },
      { text: "Situação", value: "status", width: 80 },
      {
        text: "Ação",
        value: "actions",
        sortable: false,
        width: 80,
        align: "right",
      },
    ],
    search: "",
    loading: false,
    drafts: [],
    error: "",
    alertSuccess: "",
    valid: true,
    lazy: false,
    radioGroupDraft: 0,
    dialogRemoveOrder: false,
    item_delete: "",
  }),
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.verifyDraftOrders();
    },
    async verifyDraftOrders() {
      this.drafts = [];
      this.loading = true;
      try {
        const response = await fetch(`${URL}order/admin`);
        let data = await response.json();
        console.log(data);
        if (data.length > 0) {
          this.drafts = data.map((item) => {
            return {
              ...item,
              fullCode: `${item.franchise.code} - ${item.code}`,
              providerFull: `${item.provider.code} - ${item.provider.name}`,
              franchiseFull: `${item.franchise.code} - ${item.franchise.name}`,
            };
          });
        }
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível carregar os pedidos manutenção, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    editOrder(id) {
      console.log(id);
      this.$router.push({
        name: "OrdersEditAdmin",
        params: { order: id, pageBack: "admin" },
      });
    },
    removeOrder(id) {
      console.log(id);
      this.item_delete = id;
      this.dialogRemoveOrder = true;
    },
    handleCancelRemoveOrder() {
      this.item_delete = "";
      this.dialogRemoveOrder = false;
    },
    handleConfirmRemoveOrder() {
      this.dialogRemoveOrder = false;
      this.$vuetify.goTo(0, {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      });
      this.deleteOrderDraft(this.item_delete);
    },
    async deleteOrderDraft(id) {
      this.loading = true;
      try {
        const response = await fetch(`${URL}order/${id}`, {
          method: "DELETE",
        });
        let data = await response.json();
        this.alertSuccess = "Pedido Deletado com Sucesso";
        this.verifyDraftOrders();
        console.log(data);
      } catch (error) {
        console.log(error);
        this.error =
          "Atenção: Não foi possível deletar este pedido, tente novamente mais tarde";
      } finally {
        this.loading = false;
      }
    },
    getLabel(status) {
      if (status === "validated_franchisor") {
        return "Aguardando Confirmação";
      }
      return getStatusName(status);
    },
    getColor(status) {
      if (status === "sent_franchisor") {
        return "blue darken-3";
      } else if (status === "review_franchisor") {
        return "green ligthen-2";
      } else if (status === "refused_supplier") {
        return "red ligthen-2";
      }
    },
  },
};
</script>

<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}

.image-clickable {
  cursor: pointer;
}

.cart-editing {
  background-color: #ffab00;
}

.v-text-field--outlined.border-color-field >>> fieldset {
  border-color: #666;
}
</style>
